//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  defineComponent,
  watch,
  ref,
  onMounted,
} from '@nuxtjs/composition-api';
export default defineComponent({
  props: {
    vid: {
      type: String,
      default: null,
    },
    rules: {
      type: [Object, String],
      default: '',
    },
    value: {
      type: null,
      default: null,
    },
    tag: {
      type: String,
      default: 'span',
    },
    debounce: {
      type: Number,
      default: 1,
    },
    customClass: {
      type: String,
      default: null,
    },
    require: {
      type: Boolean,
      default: false,
    },
    note: {
      type: String,
      default: null,
    },
    noteColor: {
      type: String,
      default: 'blue',
    },
    includeSupportArea: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const hasHeaderSlot = ref(false);
    const innerValue = ref(props.value);
    const requiredClass = props.require ? 'required-field' : '';

    watch(innerValue, (value, _old) => {
      context.emit('input', value);
    });

    onMounted(() => {
      // Label Slotの存在チェック
      // Label Slotがない場合は$attrs.labelを表示
      const labelSlot = context.slots.label;
      if (typeof labelSlot === 'function') {
        const labelSlotNodes = labelSlot();
        if (labelSlotNodes) hasHeaderSlot.value = labelSlotNodes.length > 0;
      }
    });

    return {
      hasHeaderSlot,
      requiredClass,
    };
  },
});
